module.exports = __webpack_public_path__ + "static/icons/icon-snow-report-6bf28247ae6b4d841ca1b7d4a9ca12c8.svg";